const MAX_DIMENSION = 1080;
const JPEG_QUALITY = 0.85;

/** Resize images, apply EXIF orientation and strip metadata before uploading */
// Keep in sync with radreport/frontend/src/app/shared/utils/compress-to-jpeg.ts
export async function compressToJpeg(file: File): Promise<File> {
  let bitmap: ImageBitmap;
  try {
    bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
  } catch {
    // iPhones convert HEIC to JPEG on upload, but not when the photo is copied to a computer and
    // uploaded with Chrome etc
    throw new Error("Unsupported image, please upload a JPEG or PNG");
  }

  try {
    const scale = Math.min(1, MAX_DIMENSION / Math.max(bitmap.width, bitmap.height));
    const canvas = new OffscreenCanvas(
      Math.max(1, Math.round(bitmap.width * scale)),
      Math.max(1, Math.round(bitmap.height * scale)),
    );
    const context = canvas.getContext("2d");
    if (!context) throw new Error("Unable to prepare the image");
    // JPEG cannot store transparency, so make transparent areas white instead of black
    context.fillStyle = "#fff";
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);

    const blob = await canvas.convertToBlob({ type: "image/jpeg", quality: JPEG_QUALITY });
    const name = file.name.replace(/\.[^.]*$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg" });
  } finally {
    bitmap.close();
  }
}
